import React from "react";
import ReactDOM from "react-dom/client";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";

import {Amplify} from "aws-amplify";
import awsExports from "./aws-exports"; 

import App from "./App";
import { msalConfig } from "./msalConfig";

console.log("Storage config:", awsExports.aws_user_files_s3_bucket,
);
Amplify.configure(awsExports);

// Initialize MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Render the app inside MsalProvider
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
